import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
  // if (window) {
  //   window.console.log = function() {}; // This will remove all console.logs from production code
  //   window.console.error = function() {};
  //   window.console.warn = function() {};
  //   window.console.group = function() {};
  //   window.console.groupEnd = function() {};
  // }
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
